import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { ISalesTeamCoverage } from 'legacy/lut/classes/models/salesTeam'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IBPOverviewSalesAgentView } from 'clickNgo/models/crud/views'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapSalesTeamCoverageFrom606Crud } from './mapping/mapSalesTeamCoverageFrom606Crud'

export const fetchSalesTeamCoverageByPartnerId = (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<ISalesTeamCoverage[]> => {
  const crud = CrudStore.get(CrudStoreItem.BPOverviewSalesAgent, options?.cacheKey)
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'Partner_ID',
        operator: Operator.EQUAL,
        value: partnerId,
      },
      {
        field: 'Roles',
        operator: Operator.NOTEQUAL,
        value: 'GCW Exception Assignment',
      },
    ],
  })
  crud.setPaging({
    startPage: 0,
    pageSize: 1000,
    page: 0,
  })
  return crud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result: { items: IBPOverviewSalesAgentView[] }) => {
      if (result && result.items) {
        return result.items.map(mapSalesTeamCoverageFrom606Crud)
      }
      return []
    })
    .catch((e) => {
      Logger.error(e)
      return []
    })
}
